/* eslint-disable react/function-component-definition */
import 'twin.macro'
import { useMemo } from 'react'
import Link from '@/components/link-component'

import { graphql, useStaticQuery } from 'gatsby'

const JobsList = () => {
  const data = useStaticQuery(graphql`
    query AllGreenhouseJobs {
      allGreenhouseJob(sort: { title: ASC }) {
        nodes {
          id
          title
          location
          departments {
            id
            name
          }
        }
      }
    }
  `)

  const jobs = data?.allGreenhouseJob?.nodes || []

  const departments = useMemo(() => {
    const results = []
    jobs.forEach((job) => {
      job.departments.forEach((dept) => {
        if (!results.some(({ id }) => id === dept.id)) results.push(dept)
      })
    })
    results.sort((d1, d2) => (d1.name < d2.name ? -1 : 1))
    return results
  }, [jobs])

  return (
    <section tw="max-w-8xl mx-auto px-5 lg:px-9 text-indigoBlue" id="open-positions">
      <div tw="text-center mb-10">
        <h3>Open Positions</h3>
        <p>
          We are growing quickly and looking for creative, collaborative, diverse, and determined team members who find
          joy in helping others.
        </p>
      </div>
      <div tw="my-8">
        {departments.map(({ id: deptId, name }) => (
          <div key={deptId} tw="mb-12">
            <h3 tw="text-2xl">{name}</h3>
            {jobs
              .filter((job) => job.departments.some((dept) => dept.id === deptId))
              .map(({ id: jobId, location, title }) => (
                <Link key={jobId} to={`/careers/${jobId}/`}>
                  <div tw="rounded-2xl shadow-even-around p-6 mb-6 sm:(px-12 py-10 mb-10) md:hover:scale-x-[1.01] md:hover:scale-y-[1.01] transition-all duration-[250ms]">
                    <span tw="block text-primaryBlue text-lg leading-tight">{title}</span>
                    <p tw="mb-0">{location}</p>
                  </div>
                </Link>
              ))}
          </div>
        ))}
      </div>
    </section>
  )
}
export default JobsList
